export const MAIN = { url: "/", title: "Главная" };
export const REGISTRATION = { url: "/registration", title: "Регистрация" };
export const PRIVACY_POLICY = {
  url: "/privacy",
  title: "Политика конфиденциальности",
};
export const QUESTIONNAIRE = { url: "/questionnaire", title: "Анкета" };
export const QUESTIONNAIRE_RESULT = {
  url: "/questionnaire/result",
  title: "Результат анкеты",
};
export const AFTER_QUESTIONNAIRE = {
  url: "/next-step-after-questionnaire",
  title: "Ты готов?",
};
export const HOME = { url: "/home", title: "Главная" };
export const PROFILE_UPDATE = {
  url: "/update",
  title: "Редактирование профиля",
};
export const SELECT_TASK_CATEGORY = {
  url: "/select-task-category",
  title: "Выбор категории задания",
};
export const TASK = {
  url: "/task",
  title: "Задание",
};
export const TASK_ID = {
  url: "/task/:id",
  title: "Задание",
};
export const RESULT_AFTER_TASK = {
  url: "/result-after-task",
  title: "Результат",
};
export const RESULT_AFTER_COMPLETE_CATEGORY = {
  url: "/result-after-complete-category",
  title: "Результат",
};
export const PERCENT_100_AND_200 = {
  url: "/percent-100-and-200",
  title: "Результат",
};
export const PROFILE = {
  url: "/profile",
  title: "Профиль",
};
export const ACHIEVEMENTS = {
  url: "/achievements",
  title: "Достижения",
};
